intra_module.filter('pageBy', () => (function(input, offset) {

    offset = input.length - offset;

    return input.slice(offset);
}));
